module.exports = __webpack_public_path__ + "img/onboarding-men.0ba9e416.svg";